import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import Icon from '../Icon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { uniqueId } from 'lodash-es';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import { toggleInputActive } from '../../Actions/QuickSearch.action';

const QuickSearchTrigger = () => {
  const quickSearch = useTypedSelector((state) => state.quickSearch);
  const { inputActive } = quickSearch;

  const [id] = useState(uniqueId());
  const dispatch = useDispatch();

  useEffect(() => {
    if (inputActive) {
      dispatch(
        addOverlay('quick-search__' + id, () =>
          dispatch(toggleInputActive(false))
        )
      );
    } else {
      dispatch(removeOverlay('quick-search__' + id));
    }
  }, [dispatch, inputActive, id]);
  return (
    <>
      <button
        onClick={() =>
          dispatch(toggleInputActive(!inputActive, inputActive))
        }
        className="quick-search-trigger px-2 py-3 store-screen:py-4 lg:py-2 hover:[&_.icon]:scale-110"
      >
        {inputActive ? (
          <Icon
            name="close"
            className="icon h-6 w-6 text-gray-700 transition ease-in-out group-[.is-light-theme]:text-white store-screen:h-8 store-screen:w-8"
          />
        ) : (
          <Icon
            name="search"
            className="icon h-6 w-6 text-gray-700 transition ease-in-out group-[.is-light-theme]:text-white store-screen:h-8 store-screen:w-8"
          />
        )}
      </button>
    </>
  );
};

export default QuickSearchTrigger;
